import React from "react";
import { connect } from "react-redux";
import { FeedbackAction } from "../../../../actions";
import { Container, Box } from "./style";
import Button from "../../../../components/button";
import SelectBox from "../../../../components/selectbox";
import { isEqual } from "lodash";
import { Field, reduxForm, SubmissionError } from "redux-form";
import Uploader from "../../../../hocs/transactionForm/components/uploader";
import FormPicker from "../../../../selectors/formPicker";
import uuidv4 from "uuid/v4";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      titles: []
    };
    this.submit = this.submit.bind(this);
  }
  static getDerivedStateFromProps(props, state) {
    let result = [];
    if (
      !state.titles.length &&
      !props.data.titles_loading &&
      props.data.modalStatus &&
      !props.data.titles_fetched
    ) {
      props.getTitles();
    }
    if (!isEqual(props.data.titles, state.titles)) {
      result.titles = props.data.titles;
    }
    if (!props.data.modalStatus) {
      props.reset();
    }
    return result;
  }
  submit(values) {
    let errors = {};
    if (!values.feedback_title_id && !this.props.data.modalData.tag) {
      errors.feedback_title_id = "موضوع الزامی است";
    }
    if (!values.text) {
      errors.text = "یادداشت الزامی است ";
    }
    if (Object.keys(errors).length) {
      throw new SubmissionError(errors);
    } else {
      this.props.store({
        ...values,
        feedback_title_id: this.props.data.modalData.tag?null:values.feedback_title_id.id,
        feedback_title_tag:this.props.data.modalData.tag?this.props.data.modalData.tag:null,
        uuid: uuidv4()
      });
    }
  }
  normalize() {
    const { data } = this.props;
    let result = [];
    data.titles.forEach(item => {
      result.push({
        ...item,
        key: item.id,
        value: item.title
      });
    });
    return result;
  }
  titlesView() {
    const { data } = this.props;
    if (data.modalData.tag) {
      this.props.change("tag", data.modalData.tag);
    } else {
      return (
        <div className="titles">
          <Field
            name="feedback_title_id"
            component={SelectBox}
            label="انتخاب موضوع بازخورد"
            options={this.normalize()}
          />
        </div>
      );
    }
  }
  TextArea(props) {
    return (
      <React.Fragment>
        <textarea
          placeholder={props.placeholder}
          onChange={e => {
            props.input.onChange(e.target.value);
          }}
          value={props.input.value}
        />
        <span className="error">{props.meta.error}</span>
      </React.Fragment>
    );
  }

  render() {
    const { data, handleSubmit, form_data } = this.props;
    if (!data.modalStatus) {
      return "";
    } else {
      return (
        <Container onClick={this.props.closeModal}>
          <Box
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <div className="header">
              <div className="title">
                <i className="icon mapsa-feedback" />
                ثبت بازخورد
              </div>
              <i
                className="close icon mapsa-close"
                onClick={this.props.closeModal}
              />
            </div>
            <form onSubmit={handleSubmit(this.submit)}>
              {this.titlesView()}
              <Field
                component={this.TextArea}
                name="text"
                placeholder="متن یادداشت"
              />
              <Uploader
                accept="image/png, image/jpeg, image/jpg"
                limit="4"
                files={form_data.values ? form_data.values.files : []}
                change={this.props.change}
              />
              <div className="file-notice">
                برای انتقال بهتر اطلاعات می‌توانید تصاویر مورد نظر خود را
                بار‌گذاری کنید.
              </div>
              <div className="buttons">
                <Button btn="primary" loading={data.loading}>
                  ارسال بازخورد
                </Button>
              </div>
            </form>
          </Box>
        </Container>
      );
    }
  }
}

const mapStateToProps = store => {
  return {
    data: store.Feedback,
    form_data: FormPicker(store, "feedback"),
    initialValues: { files: [] }
  };
};
const mapDispatchToProps = dispatch => {
  return {
    closeModal: () => {
      dispatch(FeedbackAction.closeModal());
    },
    getTitles: () => {
      dispatch(FeedbackAction.titlesRequest());
    },
    store: data => {
      dispatch(FeedbackAction.storeRequest(data));
    }
  };
};

Index = reduxForm({
  form: "feedback"
})(Index);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);
